export function clearBrowserSessionData() {
  localStorage.clear();
  sessionStorage.clear();
}
